import PersonIcon from '@mui/icons-material/PersonSharp'

const getAvatarMenuItems = ({ callback, user, params }) => {
  callback([])
}

export default getAvatarMenuItems
